import {AbstractPage} from "./AbstractPage";
import {JqueryApp} from "./JqueryApp";
import {bitcore} from "@ekliptor/payjs";
//import {BchdRest, DUST_LIMIT} from "./bitcoin-cash/BchdRest";
import {BchRecipient, BitcoinCash} from "./bitcoin-cash/BitcoinCash"
import {BigNumber} from "bignumber.js";
import {AppMessage} from "./ui/AppMessage";
import {logger} from "./utils/Log";
import {ChainTools} from "./bitcoin-cash/ChainTools";
import {fromSatoshis} from "./bitcoin-cash/chain-utils";
import {PromptRest} from "./bitcoin-cash/PromptRest";


export class Merchant extends AbstractPage {
    protected bchd: PromptRest;
    protected bitcoinCash: BitcoinCash = null;
    protected chainTools: ChainTools = null;

    constructor(app: JqueryApp) {
        super(app);
        //this.bchd = new PromptRest(this.app.getConfig().bchdRestAddress);
        this.bchd = new PromptRest(this.app.getConfig().apiBase + "/node-api")
        this.chainTools = new ChainTools(this.app.getConfig().apiBase, this.app.getWebHelpers());

        this.app.$(() => { // jQuery 3.0 "document.ready"
            this.initPage();
            this.addEventListeners();
        });
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected initPage() {
        if (this.app.getConfig().balance <= 0.0)
            this.app.$("#withdraw-btn").prop("disabled", true);
    }

    protected addEventListeners() {
        // =========== Account page ===========
        // ====================================
        this.app.$("#create-wallet-btn").on("click", async (event) => {
            this.toggleExpandButtonIcon(this.app.$(event.target).find(".toggleIcon").eq(0));
            this.closeExpandButton(this.app.$("#import-xpub-btn"));
            this.app.$(".create-xpub").fadeToggle("slow");
            this.app.$(".import-xpub").fadeOut("slow");

            let hdPrivateKey = new bitcore.HDPrivateKey();
            let hdPublicKey = hdPrivateKey.hdPublicKey;
            this.app.$("#xpub-new").val(hdPublicKey.xpubkey.toString());
            // @ts-ignore
            //this.app.$("#wif-new").val(hdPrivateKey.privateKey.toWIF()); // we can't derive keys from WIF
            this.app.$("#wif-new").val(hdPrivateKey.toString());

            //let address = new bitcore.Address(hdPublicKey.publicKey, bitcore.Networks.livenet); // we don't scan for this address, use index 0
            //let derivedAddress = new bitcore.Address(hdPublicKey.derive(0).publicKey, bitcore.Networks.livenet); // use API call just to ensure we use same address
            const address = await this.chainTools.createAddress(hdPublicKey.xpubkey.toString(), 0);
            this.app.$("#address-new").val(address.cashAddress);
        });
        this.app.$("#import-xpub-btn").on("click", (event) => {
            this.toggleExpandButtonIcon(this.app.$(event.target).find(".toggleIcon").eq(0));
            this.closeExpandButton(this.app.$("#create-wallet-btn"));
            this.app.$(".import-xpub").fadeToggle("slow");
            this.app.$(".create-xpub").fadeOut("slow");
        });
        this.app.$("#use-xpub-btn").on("click", (event) => {
            if (window.confirm(this.app.getConfig().tr.confirmWalletBackup) !== true)
                return;
            const currentXpub = this.app.$("#xpub-new").val();
            this.app.$("#xpub").val(currentXpub);
        });

        this.app.$("#withdraw-btn").on("click", (event) => {
            this.app.$("#withdraw-section").fadeToggle("slow");
            this.app.$('html, body').animate({
                scrollTop: this.app.$("#withdrawal-form").offset().top - 100
            }, 1200);
        });
        this.app.$("#withdrawal-form").on("submit", (event) => {
            event.preventDefault(); // we submit using ajax
            this.withdrawFromWallet(event.target);
        });

        this.app.$("#enforceSignatures").on("change", (event) => {
            const checkbox = this.app.$(event.target);
            if (checkbox.prop("checked") !== true)
                return;
            if (window.confirm(this.app.getConfig().tr.confirmSignatures) !== true)
                checkbox.prop("checked", false);
        });

        this.app.$("#enableSlpTokens").on("change", (event) => {
            const checkbox = this.app.$(event.target);
            if (checkbox.prop("checked") !== true)
                return;
            if (window.confirm(this.app.getConfig().tr.confirmSlpTokens) !== true)
                checkbox.prop("checked", false);
        });

        this.app.$("#show-frame-demo").on("click", (event) => {
            this.app.$(event.target).fadeOut("slow");
            const frame = this.app.$("#prompt-frame");
            frame.attr("src", frame.attr("data-src"));
            frame.fadeIn("slow");
        });

        this.app.$(".deleteUrlBtn").on("click", (event) => {
            if (confirm(this.app.getTr().get("reallyRemoveUrl"))) {
                let token = event.target.dataset.token
                if (token === undefined)
                    token = event.target.parentElement.dataset.token
                window.location.replace(this.app.getConfig().pathUrlShortener + "?op=remove&token=" + token);
            }
        });

        this.app.$(".editUrlBtn").on("click", (event) => {
            let token = event.target.dataset.token
            if (token === undefined)
                token = event.target.parentElement.dataset.token
            window.location.replace(this.app.getConfig().pathUrlShortener + "?token=" + token);
        });
    }

    protected toggleExpandButtonIcon(icon: JQuery<HTMLElement>) {
        if (icon.hasClass("fa-arrow-up") === true) {
            icon.removeClass("fa-arrow-up").addClass("fa-arrow-down");
        }
        else
            icon.removeClass("fa-arrow-down").addClass("fa-arrow-up");
    }

    protected closeExpandButton(button: JQuery<HTMLElement>) {
        const icon = button.find(".toggleIcon").eq(0);
        icon.removeClass("fa-arrow-up").addClass("fa-arrow-down");
    }

    protected async withdrawFromWallet(form :HTMLElement) {
        const $form = this.app.$(form);
        const config = this.app.getConfig();
        let privateKey = $form.find("#wallet-wif").val() as string;
        const bchAddress = $form.find("#withdrawal-address").val() as string;
        let amount = parseFloat($form.find("#withdrawal-amount").val() as string);
        //const xpub = this.app.$("#xpub").val() as string;
        try {
            //amount -= fromSatoshis(DUST_LIMIT)*5; // already subtracted on server. Why needed again?
            if (amount <= 0.0)
                throw new Error("Withdrawal balance must be positive.");
            this.app.$("#withdraw-progress").fadeIn("slow");

            const addressCount = parseInt(this.app.$("#address-count").text() as string);
            let withdrawnAmount = 0.0;
            for (let i = 0; i < addressCount; i++)
            {
                let derivedHdKey = BitcoinCash.getDerivedKey(privateKey, i);
                this.bitcoinCash = new BitcoinCash(derivedHdKey, this.bchd);
                const xpub = derivedHdKey.hdPublicKey.xpubkey.toString();
                const address = await this.chainTools.createAddress(xpub, i);
                //this.bitcoinCash.setBchAddress(address.cashAddress);

                // get UTXO and withdraw everything from it
                const utxo = await this.bchd.getBchAddressUnspentOutputs(address.cashAddress, true);
                if (utxo.bchOutputs.length === 0)
                    continue;
                let availableAmountBch = 0.0;
                utxo.bchOutputs.forEach((out) => {
                    availableAmountBch += fromSatoshis(parseInt(out.value));
                });
                const neededAmountRemaining = amount - withdrawnAmount;
                const toWithdraw = Math.min(neededAmountRemaining, availableAmountBch);
                withdrawnAmount += toWithdraw;

                const receivers: BchRecipient[] = [{bchAddress: bchAddress, amount: toWithdraw}];
                // @ts-ignore
                const transaction = await this.bitcoinCash.signTransactionWithUtxo(receivers, derivedHdKey.privateKey, address, utxo);
                logger.verbose(transaction)
                let txid = await this.bchd.submitTransaction(transaction.toString());
                logger.info("Submitted TX with TXID %s", txid); // or transaction.id
                if (withdrawnAmount >= amount)
                    break;
            }

            // show success message and update balance
            const msg = new AppMessage(config.tr.withdrawalSuccess, "success");
            msg.display();
            this.app.$("#withdraw-progress").fadeOut("slow");
            this.app.$("#balance").text(config.tr.updating); // TODO API call to compute new BCH balance and USD value
        }
        catch (err) {
            const msg = new AppMessage(config.tr.withdrawalFailed, "danger");
            msg.display();
            console.error("error starting withdrawal", err)
        }
    }
}
